/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：616
 */

"use strict"

var r = require(/* 802 */"./802")
exports.a = r.b
